import { ThemeId } from '@stadionhq-v3/core';
import { TabbedCarouselProps } from '@stadionhq-v3/base-ui';
import {
  ArticlePage,
  Link,
  TabbedCarouselBlock,
} from '@graphql/__generated__/graphql';
import { Locale } from '@core/constants/locales.constants';
import { isRtlLocale } from '@utils/locales.utils/locales.utils';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { Translations } from '@lib/dictionary-keys/__generated__';
import { Fragment, ReactNode } from 'react';
import { ArticleCardRenderer } from '@components/helpers/article-card-renderer';
import { ChevronLeft, ChevronRight } from '@components/icons';
import { linkTransform } from '../atoms';

type TabbedCarouselData = {
  tabTitle?: string;
  articles?: CleanContentful<ArticlePage>[];
  cta?: CleanContentful<Link>;
}[];

const tabbedCarouselBlockTransform = (
  {
    tabbedCarouselTitle,
    subTitle,
    theme,
  }: CleanContentful<TabbedCarouselBlock>,
  locale: Locale,
  dictionary: {
    previousAction: Translations['common']['action']['previous'];
    nextAction: Translations['common']['action']['next'];
    featured?: Translations['news']['label']['featured'];
  },
  content: TabbedCarouselData
): TabbedCarouselProps => ({
  title: tabbedCarouselTitle || '',
  subTitle: subTitle || '',
  tabbedCarouselData: content?.map((item) => ({
    tabTitle: item?.tabTitle || '',
    carousel: item?.articles?.filter(Boolean).map((article) => (
      <Fragment key={article.id}>
        <ArticleCardRenderer
          article={article}
          locale={locale}
          dictionary={dictionary}
        />
      </Fragment>
    )) as ReactNode[],
    cta: item?.cta?.url ? linkTransform(item?.cta, locale) : undefined,
  })),
  theme: {
    themeId: theme?.themeId as ThemeId,
    title: theme?.title as string,
  },
  previousButton: {
    text: dictionary.previousAction,
    iconBefore: isRtlLocale(locale) ? <ChevronRight /> : <ChevronLeft />,
  },
  nextButton: {
    text: dictionary.nextAction,
    iconBefore: isRtlLocale(locale) ? <ChevronLeft /> : <ChevronRight />,
  },
  options: {
    direction: isRtlLocale(locale) ? 'rtl' : 'ltr',
  },
});

export default tabbedCarouselBlockTransform;
